import { ACTION_TYPES, SUBPAGES, TSubPages } from './types';

interface Action {
  type: ACTION_TYPES;
  payload: {
    applicantIndex?: number;
    subPage: SUBPAGES;
    isDirty: boolean;
  };
}

export const updateSubPageIsDirty = (subPage: keyof TSubPages, isDirty: boolean): Action => ({
  type: ACTION_TYPES.UPDATE_SUBPAGE_DIRTY,
  payload: {
    subPage,
    isDirty,
  },
});

export const updateApplicantSubPageIsDirty = (
  applicantIndex: number,
  subPage: keyof TSubPages['APPLICANTS'][0],
  isDirty: boolean,
): Action => ({
  type: ACTION_TYPES.UPDATE_APPLICANT_SUBPAGE_DIRTY,
  payload: {
    applicantIndex,
    subPage,
    isDirty,
  },
});
